<template>
    <div class="view view--password-reset">
        <password-reset />
    </div>
</template>

<script>
    import passwordReset from '../../components/PasswordReset.vue';

    export default {
        components: {
            passwordReset
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/PasswordReset.vue